import React from 'react';
import { 
  Box, 
  Heading, 
  Card, 
  CardHeader, 
  CardBody, 
  Breadcrumb, 
  BreadcrumbItem, 
  BreadcrumbLink,
  Text,
  VStack
} from '@chakra-ui/react';
import { ChevronLeftIcon } from '@chakra-ui/icons';
import ResponsiveLayout from '../shared/ResponsiveLayout';
import SurveyTable from '../shared/SurveyTable';

const AdminSurveyManagement = () => {
  return (
    <ResponsiveLayout>
      <Box dir="rtl" fontFamily="Cairo, sans-serif">
        {/* Breadcrumb / Page Header */}
        <VStack align="start" spacing={2} mb={8}>
          <Breadcrumb spacing="8px" separator={<ChevronLeftIcon color="gray.500" />} fontSize="sm" color="gray.600">
            <BreadcrumbItem>
              <BreadcrumbLink href="/admin">لوحة التحكم</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem isCurrentPage>
              <BreadcrumbLink href="#">إدارة الاستبيانات</BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
          <Heading size="xl" color="#2C3E50">إدارة الاستبيانات</Heading>
          <Text color="gray.600">عرض وإدارة استبيانات المنصة ومتابعة نتائج الطلاب</Text>
        </VStack>

        <Card variant="outline" borderRadius="xl" boxShadow="sm" bg="white" overflow="hidden">
          <CardHeader bg="gray.50" py={4}>
            <Heading size="md" color="#2C3E50">قائمة الاستبيانات</Heading>
          </CardHeader>
          <CardBody>
            <SurveyTable />
          </CardBody>
        </Card>
      </Box>
    </ResponsiveLayout>
  );
};

export default AdminSurveyManagement;
